import script from "./AudioVisualizer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioVisualizer.vue?vue&type=script&setup=true&lang=ts"

import "./AudioVisualizer.vue?vue&type=style&index=0&id=d2bd7d5c&lang=scss"

const __exports__ = script;

export default __exports__